import $ from 'jquery';
import whatInput from 'what-input';

window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

$(document).ready(function(){

$('.menu-toggle').on('click', function() {
	$(this).toggleClass('open');
	$('.overlay').toggleClass('open');
});

	// Toggle and animate scroll-icon on desktop
	$('.icon-search').click(function() {
		$('.search-icon').toggleClass('active');
  if ($(this).attr('data-toggle')) {
    $(this).removeAttr('data-toggle');
    $(this).attr('data-close', "search-bar");
  } else {
    $(this).removeAttr('data-close');
    $(this).attr('data-toggle', "search-bar");
  }
})

	// ScrollReveal
	ScrollReveal().reveal('section .container, .the-post', {
		duration: 1000,
		scale: 0.85

	});

});
